import { CartSummaryResponse } from 'src/app/feature/cart/models/cart-summary-response.model';

export interface CartState {
	cart: {
		cartId: number;
		cartKey: number;
	};
	summary: CartSummaryResponse;
}

export const initialState: CartState = {
	cart: null,
	summary: null,
};
